export class PreviewDirectoryRestoreRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "snapshotId",
            "baseName": "snapshotId",
            "type": "string",
            "format": ""
        },
        {
            "name": "entities",
            "baseName": "entities",
            "type": "Array<DirectoryEntityRef>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return PreviewDirectoryRestoreRequest.attributeTypeMap;
    }
    constructor() {
    }
}
